import { yupResolver } from '@hookform/resolvers/yup';

// Centralises the yupResolver → Resolver<FieldValues> cast caused by a package-version type mismatch.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const typedYupResolver = (schema: any) => yupResolver(schema) as any;
